import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import {OriginatorFilter, OriginatorItem, OriginatorsState} from './types';
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<OriginatorsState, RootState> = {
  getOriginators: ({commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      axios({url: '/lk-api/sender', params: data})
        .then(resp => {
          let data = resp.data.map((item:any) => {
            item.status = item.status.name
            return item
          })
          commit('setOriginators', data);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
      })
  },
  getOriginatorItem: ({commit, dispatch},id) => {
    return new Promise((resolve, reject) => {
      axios({url: `/originators/${id}`})
        .then((resp:any) => {
          let originatorItem = <OriginatorItem>resp.data;
          originatorItem.id = id;
          commit('setOriginatorItem', originatorItem);
          resolve(originatorItem)
        })
        .catch(err => {
          reject(err)
        })
      })
  },
  saveOriginator: ({commit, dispatch}, data:OriginatorItem) => {
    return new Promise((resolve, reject) => {
      axios({
          method: data.id ? 'put' : 'post',
          url: '/lk-api/sender' + (data.id ?? ''),
          data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getOriginators');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
      })
  },
  deleteOriginator: ({commit, dispatch}, data: OriginatorItem) => {
    return new Promise((resolve, reject) => {
      axios({
          method: 'delete',
          url: '/lk-api/sender',
          data: data
      })
        .then((resp:any) => {
          dispatch('getOriginators');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
      })
  },
  exportOriginators: ({commit, dispatch}, data: OriginatorFilter) => {
    return directDownload('/originators/export', data)
  },
};